export default "__VITE_ASSET__CHgxyXs7__"